export default __webpack_public_path__ + "static/media/joseph_proietto.45148c12.jpg";